/**
 * Utility to get the height of a hidden element (display: none)
 */
export const getHiddenElementHeight = (el: HTMLElement | null): number => {
  if (!el) return 0;

  // Save original styles
  const originalDisplay = el.style.display;
  const originalVisibility = el.style.visibility;
  const originalPosition = el.style.position;

  // Temporarily show the element
  el.style.display = 'block';
  el.style.visibility = 'hidden';
  el.style.position = 'absolute';

  // Measure height
  const height = el.offsetHeight;

  // Restore original styles
  el.style.display = originalDisplay;
  el.style.visibility = originalVisibility;
  el.style.position = originalPosition;

  return height;
};

export default {
  getHiddenElementHeight
};
